<div style="padding: 10px !important;  width:100% !important; background-color: white" class="box-padrao-table">
  <h4 style="padding-top: 15px; font-size: 20px; font-weight: 500; color: #434a54;">Últimos Protocolos</h4>

  <div style="padding-left: 80%">
    <mat-form-field style="width:100%">
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar">
    </mat-form-field>
  </div>
  <mat-progress-bar *ngIf="loadProtocolos" class="progress-bar" mode="indeterminate"></mat-progress-bar>
  <div class="table-container">
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" matSort style="width:100%;">
        <!-- Protocolo -->
        <ng-container matColumnDef="idProtocolo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Protocolo </th>
          <td mat-cell *matCellDef="let element"> {{element.idProtocolo}} </td>
        </ng-container>
        <!-- Documento -->
        <ng-container matColumnDef="documento">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Documento </th>
          <td mat-cell *matCellDef="let element"> {{element.documento}} </td>
        </ng-container>
        <!-- Valor -->
        <ng-container matColumnDef="valor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Valor </th>
          <td mat-cell *matCellDef="let element">{{element.valor | currency:'BRL':true:'1.2-4'}} </td>
        </ng-container>
        <!-- Data Criação -->
        <ng-container matColumnDef="dataCriacaoNf">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Data Criação </th>
          <td mat-cell *matCellDef="let element"> {{element.dataCriacaoNfExibicao}} </td>
        </ng-container>
        <!-- Data Emissão -->
        <ng-container matColumnDef="dataEmissaoNf">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Data Emissão </th>
          <td mat-cell *matCellDef="let element"> {{element.dataEmissaoNfExibicao}} </td>
        </ng-container>
        <!-- Data Vencimento -->
        <ng-container matColumnDef="dataVencimentoNf">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Data Vencimento </th>
          <td mat-cell *matCellDef="let element"> {{element.dataVencimentoNfExibicao}} </td>
        </ng-container>
        <!-- Fornecedor -->
        <ng-container matColumnDef="nomeFornecedor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Fornecedor </th>
          <td mat-cell *matCellDef="let element"> {{element.nomeFornecedor}} </td>
        </ng-container>
        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
          <td mat-cell *matCellDef="let element"> {{element.status}} </td>
        </ng-container>
        <!-- edit -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
          </th>
          <td mat-cell *matCellDef="let element">
            <a mat-button *ngIf="element.naoFiscal === 1" [routerLink]="['/protocolo-naofiscal', element.idProtocolo]" (click)="NavigateProtocolo(element.documento)" color="orange" target="_blank">
              <mat-icon>edit</mat-icon>
            </a>
            <a mat-button *ngIf="element.naoFiscal !== 1" [routerLink]="['/protocolo-fiscal', element.idProtocolo]" (click)="NavigateProtocolo(element.documento)" color="orange" target="_blank">
              <mat-icon>edit</mat-icon>
            </a>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
  <mat-paginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
</div>